module.exports = __webpack_public_path__ + "arrow-step-backward.f8e8fa6bb0595e3c04df.svg";


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/img/icon/arrow-step-backward.svg
// module id = ../../../../../src/img/icon/arrow-step-backward.svg
// module chunks = styles